import { Constants } from 'app/utility/constants';
import { FieldGroupModel } from "app/models/shared/fieldGroup.model";
import { FieldModel } from "app/models/shared/field.model";
import { FieldComponent } from 'app/components/shared/field/field.component';
import { PriceEditorModel } from './priceEditor.model';
import { FormService } from 'app/services/form.service';

export class TabModel
{

    public label: string;
    public id: string;
    public fieldGroups: FieldGroupModel[];
    public classes: string;
    public data: any;

    public hidden: boolean;
    public dirty: boolean;
    public errorsExist: boolean;
    public errorCount: number;

    public canView: boolean;
    public canEdit: boolean;

    constructor(
        label: string,
        data: any,
        field_groups: FieldGroupModel[] = [],
        dirty: boolean = false,
        id: string = null,
        classes: string = "",
        canView: boolean = false,
        canEdit: boolean = false,
    )
    {
        this.label = label;
        this.data = data;
        this.id = id || label;
        this.fieldGroups = field_groups;
        this.classes = classes;

        this.errorsExist = false;
        this.errorCount = 0;
        if (dirty)
        {
            this.makeDirty();
        }
        this.canView = canView;
        this.canEdit = canEdit;
    }

    public addFieldGroup(fieldGroup: FieldGroupModel): number
    {
        return this.fieldGroups.push(fieldGroup);
    }

    public handleFieldChanged(ev: any)
    {
        // console.log(ev);
        this.dirty = true;
        this.errorsExist = false;
        this.errorCount = 0;

        //see if this field has children
        var changedField: FieldModel = ev.detail.field;
        if (changedField.hasChildren)
        {
            switch (changedField.type)
            {
                case "toggle":
                    this.checkToggleChildren(changedField);
                    break;
                case "segment":
                    this.checkSegmentChildren(changedField);
                    break;
                case "lookup":
                case "select":
                    this.checkLookupChildren(changedField);
                    break;
                // case "autocomplete":
                //     if (ev.autocomplete)
                //     {
                //         this.checkAddressChildren(changedField, <AddressLookupModel>ev.autocomplete);
                //     }
                //     break;
                // case "autocomplete-company":
                //     if (ev.autocomplete)
                //     {
                //         this.checkCompanyChildren(changedField, <CompanyLookupDetailsModel>ev.autocomplete);
                //     }
                //     break;
                case "number":
                case "currency":
                case "decimal":
                    this.checkCalculationChildren(changedField);
                    break;
            }
        }

        for (let field_group of this.fieldGroups)
        {
            for (let field of field_group.fields)
            {
                if (field.invalid)
                {
                    console.log("Field is invalid ", field);
                    this.errorsExist = true;
                    this.errorCount++;
                    // console.log(this.errorCount);
                }
            }

            //if we need to toggle a group, then loop through the fields to see if we need to toggle this one...
            if (field_group.toggleVisibilityOn)
            {
                var toggleVisibilityOn = field_group.toggleVisibilityOn;
                var toggleFieldValue = "";
                field_group.hidden = true;

                for (let field_group_loop of this.fieldGroups)
                {
                    for (let field_test of field_group_loop.fields)
                    {
                        //toggle the group if there is a rule
                        // console.log(field_test);
                        if (field_test.id == field_group.toggleVisibilityOn && field_test.value.toString() == field_group.toggleVisibleWhen)
                        {
                            field_group.hidden = false;
                        }
                    }
                }
            }
        }
    }

    public checkLookupChildren(changedField: FieldModel, recursive: boolean = false)
    {
        // console.log("checkLookupChildren", changedField);
        for (let field_group_loop of this.fieldGroups)
        {
            for (let field_test of field_group_loop.fields)
            {
                //  console.log(field_test.parent, '==', changedField.id);
                if (field_test.parent && field_test.parent == changedField.id)
                {
                    // console.log("found a child, " + field_test.id, field_test.toggleEditableWhen, changedField.editValue);


                    if (field_test.parentLookupId != changedField.editValue)
                    {
                        // console.log("Parent lookup id changed", field_test.parentLookupId, changedField.editValue);
                        field_test.parentLookupId = changedField.editValue;
                        field_test.editValue = '00000000-0000-0000-0000-00000000000';
                        if (field_test.hasChildren)
                        {
                            // console.log("has children", field_test.hasChildren);
                            this.checkLookupChildren(field_test, true);
                        }
                    }

                    //match on multiple options
                    if (field_test.toggleEditableWhen && field_test.toggleEditableWhen.indexOf('|') > -1)
                    {
                        // console.log("Toggle editable for field", field_test);
                        // console.log("changed field: ", changedField.editCaption);
                        // console.log("target field: ", field_test.toggleEditableWhen);
                        // console.log("comparison", (changedField.editCaption+'' == field_test.toggleEditableWhen+''));
                        // // console.log("comparison", (changedField.value+'' == field_test.toggleEditableWhen+''));
                        if (field_test.toggleEditableWhen.indexOf(changedField.editCaption) > -1 ||
                            field_test.toggleEditableWhen.indexOf(changedField.value) > -1)
                        {
                            field_test.editable = (!field_test.inverseCheck);
                        }
                        else
                        {
                            field_test.editable = field_test.inverseCheck;
                        }
                        //    console.log("Toggled to: ", field_test.editable);
                    }
                    else if (field_test.toggleEditableWhen && field_test.toggleEditableWhen != "")
                    {
                        // console.log("Toggle editable for field", field_test);
                        if (field_test.parentLookupId == field_test.toggleEditableWhen)
                        {
                            field_test.editable = (!field_test.inverseCheck);
                        }
                        else
                        {
                            field_test.editable = field_test.inverseCheck;
                        }

                        if (field_test.editable)
                        {
                            field_test.dirty = true;
                            field_test.value = '';
                            if (field_test.required)
                            {
                                console.log("Setting field to invalid as it is required", field_test.id);
                                field_test.invalid = true;
                            }
                        }
                        else
                        {
                            field_test.dirty = false;
                            field_test.invalid = false;
                        }

                        // console.log("Toggled to: ", field_test.editable);
                    }

                    //match on multiple options
                    if (field_test.toggleVisibleWhen && field_test.toggleVisibleWhen.indexOf('|') > -1 ||
                        field_test.toggleVisibleWhen && field_test.toggleVisibleWhen.indexOf('|') > -1)
                    {
                        // console.log("Toggle visible for field", field_test);
                        if (field_test.toggleVisibleWhen.indexOf(changedField.editCaption) > -1 ||
                            field_test.toggleVisibleWhen.indexOf(changedField.value) > -1)
                        {
                            field_test.viewInEdit = (!field_test.inverseCheck);
                        }
                        else
                        {
                            field_test.viewInEdit = field_test.inverseCheck;
                        }
                        // console.log("Toggled to: ", field_test.viewInEdit);
                    }
                    else if (field_test.toggleVisibleWhen && field_test.toggleVisibleWhen != "")
                    {
                        // console.log("Toggle visible for field", field_test);
                        if (field_test.parentLookupId == field_test.toggleVisibleWhen)
                        {
                            field_test.viewInEdit = (!field_test.inverseCheck);
                        }
                        else
                        {
                            field_test.viewInEdit = field_test.inverseCheck;
                        }
                        // console.log("Toggled to: ", field_test.viewInEdit);
                    }
                }
            }
        }
    }

    public checkToggleChildren(changedField: FieldModel)
    {

        console.log("checkToggleChildren", changedField);
        for (let field_group_loop of this.fieldGroups)
        {
            for (let field_test of field_group_loop.fields)
            {
                if (field_test.parent == changedField.id)
                {
                    console.log("found a child, " + field_test.id);
                    if (field_test.toggleEditableWhen)
                    {
                        if
                            (
                            (field_test.toggleEditableWhen == "true" && changedField.value)
                            ||
                            (field_test.toggleEditableWhen == "false" && !changedField.value)
                        )
                        {
                            field_test.editable = true;
                        }
                        else
                        {
                            field_test.editable = false;
                        }

                        if (field_test.editable)
                        {
                            field_test.dirty = true;
                            field_test.value = '';
                            if (field_test.required)
                            {
                                console.log("Setting field to invalid as it is required", field_test.id);
                                field_test.invalid = true;
                            }
                        }
                        else
                        {
                            field_test.dirty = false;
                            field_test.invalid = false;
                        }

                    }


                    if (field_test.toggleVisibleWhen)
                    {
                        if
                            (
                            (field_test.toggleVisibleWhen == "true" && changedField.value)
                            ||
                            (field_test.toggleVisibleWhen == "false" && !changedField.value)
                        )
                        {
                            // console.log("toggle visible");
                            field_test.viewInEdit = true;
                        }
                        else
                        {
                            // console.log("toggle visible off");
                            field_test.viewInEdit = false;
                        }

                    }
                }
            }
        }
    }

    public checkSegmentChildren(changedField: FieldModel)
    {
        // console.log("checkSegmentChildren", changedField);
        for (let field_group_loop of this.fieldGroups)
        {
            for (let field_test of field_group_loop.fields)
            {
                //  console.log(field_test.parent, '==', changedField.id);
                if (field_test.parent && field_test.parent == changedField.id)
                {
                    //match on multiple options
                    if (field_test.toggleEditableWhen && field_test.toggleEditableWhen.indexOf('|') > -1)
                    {
                        // console.log("Toggle editable for field", field_test);
                        // console.log("changed field: ", changedField.editCaption);
                        // console.log("target field: ", field_test.toggleEditableWhen);
                        // console.log("comparison", (changedField.editCaption+'' == field_test.toggleEditableWhen+''));
                        // // console.log("comparison", (changedField.value+'' == field_test.toggleEditableWhen+''));
                        if (field_test.toggleEditableWhen.indexOf(changedField.editCaption) > -1 ||
                            field_test.toggleEditableWhen.indexOf(changedField.value) > -1)
                        {
                            field_test.editable = (!field_test.inverseCheck);
                        }
                        else
                        {
                            field_test.editable = field_test.inverseCheck;
                        }
                        //    console.log("Toggled to: ", field_test.editable);
                    }
                    else if (field_test.toggleEditableWhen && field_test.toggleEditableWhen != "")
                    {
                        // console.log("Toggle editable for field", field_test);
                        if (changedField.value == field_test.toggleEditableWhen)
                        {
                            field_test.editable = (!field_test.inverseCheck);
                        }
                        else
                        {
                            field_test.editable = field_test.inverseCheck;
                        }

                        if (field_test.editable)
                        {
                            field_test.dirty = true;
                            field_test.value = '';
                            if (field_test.required)
                            {
                                field_test.invalid = true;
                            }
                        }
                        else
                        {
                            field_test.dirty = false;
                            field_test.invalid = false;
                        }

                        // console.log("Toggled to: ", field_test.editable);
                    }

                    //match on multiple options
                    if (field_test.toggleVisibleWhen && field_test.toggleVisibleWhen.indexOf('|') > -1 ||
                        field_test.toggleVisibleWhen && field_test.toggleVisibleWhen.indexOf('|') > -1)
                    {
                        // console.log("Toggle visible for field", field_test);
                        if (field_test.toggleVisibleWhen.indexOf(changedField.editCaption) > -1 ||
                            field_test.toggleVisibleWhen.indexOf(changedField.value) > -1)
                        {
                            field_test.viewInEdit = (!field_test.inverseCheck);
                        }
                        else
                        {
                            field_test.viewInEdit = field_test.inverseCheck;
                        }
                        // console.log("Toggled to: ", field_test.viewInEdit);
                    }
                    else if (field_test.toggleVisibleWhen && field_test.toggleVisibleWhen != "")
                    {
                        // console.log("Toggle visible for field", field_test);
                        if (changedField.value == field_test.toggleVisibleWhen)
                        {
                            field_test.viewInEdit = (!field_test.inverseCheck);
                        }
                        else
                        {
                            field_test.viewInEdit = field_test.inverseCheck;
                        }
                        // console.log("Toggled to: ", field_test.viewInEdit);
                    }
                }
            }
        }
        
    }

    public initialiseCalculationChildren()
    {
        for (let field_group_loop of this.fieldGroups)
        {
            for (let field_test of field_group_loop.fields)
            {
                if (field_test.calculationField)
                {
                    //find the calculation field parent
                    for (let x_field_group_loop of this.fieldGroups)
                    {
                        for (let x_field_test of x_field_group_loop.fields)
                        {
                            if (field_test.calculationFields.includes(x_field_test.id))
                            {
                                this.checkCalculationChildren(x_field_test, false);
                            }
                        }
                    }
                }
            }
        }
    }
    public checkCalculationChildren(changedField: FieldModel, makeDirty: boolean = true)
    {
        // console.log("checkCalculationChildren", changedField);
        for (let field_group_loop of this.fieldGroups)
        {
            for (let field_test of field_group_loop.fields)
            {
                if (field_test.calculationField && field_test.calculationFields && field_test.calculationFields.length > 0 && field_test.calculationFields.includes(changedField.id))
                {
                    // console.log("found a child, " + field_test.id);

                    var total = 0;
                    var i = 0;
                    for (let operand of field_test.calculationFields)
                    {
                        i++;
                        // console.log(operand);
                        for (let x_field_group_loop of this.fieldGroups)
                        {
                            for (let x_field_test of x_field_group_loop.fields)
                            {

                                if (x_field_test.id == operand)
                                {

                                    var value = parseFloat(x_field_test.value);
                                    if (!value) value = 0;
                                    // console.log(operand, value);
                                    if (i == 1)
                                    {
                                        total = value;
                                    }
                                    else
                                    {
                                        switch (field_test.calculationOperator)
                                        {
                                            case "-":
                                                total -= value;
                                                break;
                                            case "+":
                                                total += value;
                                                break;
                                            default:
                                                // console.log("Unsupported operator type ", field_test.calculationOperator);
                                                break;
                                        }
                                    }
                                }
                            }
                        }
                    }

                    // console.log("Calculation field updated", field_test.id, total);
                    field_test.value = total;
                    field_test.dirty = true;
                    this.checkCalculationChildren(field_test);
                }
            }
        }
    }


    public syncFormWithObject(): boolean
    {
        if (this.dirty)
        {
            return FormService.syncFormWithObject(this.fieldGroups, this.data);
        }
        return false;
    }

    public makeDirty(): void
    {
        this.dirty = true;

        this.errorCount = 0;
        this.errorsExist = false;
        var field_groups = this.fieldGroups;
        for (let field_group of field_groups)
        {
            for (let field of field_group.fields)
            {
                field.dirty = true;
                if ((field.invalid) || (field.required && (field.value == '' || field.value == Constants.EmptyGuid)) && !field.parent)
                {
                    console.log("Field is invalid", field.id);
                    this.errorsExist = true;
                    this.errorCount++;
                }
            }
        }
    }

}
